import RefreshIcon from "@lyteflo/assets/icons/refresh.svg?react";
import { LightButton } from "@lyteflo/components";
import { ToastLevel } from "@lyteflo/types";
import { useToast } from "@lyteflo/utils";
import { useEffect } from "preact/compat";
import { useTranslation } from "react-i18next";

interface RefreshNotificationProps {
  onRefresh: () => void;
  isVisible: boolean;
}

export const RefreshNotification = ({
  onRefresh,
  isVisible,
}: RefreshNotificationProps) => {
  const { t } = useTranslation();
  const { addToast, removeToastByDeduplicationId } = useToast();

  useEffect(() => {
    if (isVisible) {
      const toast = {
        level: ToastLevel.INFO,
        text: t("shared:newVersionAvailable"),
        persistent: true,
        fixed: true,
        deduplicationId: "app-refresh-info",
        children: (
          <div className="lf-flex lf-items-center lf-justify-between lf-w-full">
            <span>{t("shared:newVersionAvailable")}</span>
            <LightButton onClick={onRefresh} className="lf-h-6 lf-ml-3">
              <RefreshIcon className="lf-w-3 lf-h-3" />
              <span className="lf-text-sm">{t("shared:refresh")}</span>
            </LightButton>
          </div>
        ),
      };

      addToast(toast);
    } else {
      removeToastByDeduplicationId("app-refresh-info");
    }
  }, [isVisible, t, addToast, removeToastByDeduplicationId, onRefresh]);

  return null;
};
